<template lang="pug">
  page
    .row
      .col-sm-4(v-if="stall.startup")
        .startup-details.mx-5.py-5.mt-5
          img.img-fluid(:src='$backend+"/storage/logos/"+stall.startup.logo')
          .text-center
            b {{stall.startup.name}}
          .text-muted.text-center {{stall.startup.address}}
          a.text-center.small.mx-auto.d-block.mt-2(:href="stall.startup.website" target="_blank") Visit Website
          a.text-center.small.mx-auto.d-block.mt-2(:href="stall.startup.linkedin" target="_blank") LinkedIn
          p.text-center.mt-3 

        .row
          .col-sm-12.text-center
            button.button.btn.btn-warning.mt-5(@click="business_card()" :disabled="sending && loading.business")
              span.spinner-border.spinner-border-sm.mr-2(v-if="sending && loading.business")
              | Business Card
          .col-sm-12.text-center(v-if="stall.busy=='online'")
            button.button.glowing.btn.btn-danger.mt-5(@click="live_interact()" :disabled="sending && loading.live")
              span.spinner-border.spinner-border-sm.mr-2(v-if="sending && loading.live")
              | Live Interaction
          .col-sm-12.text-center
            button.button.btn.btn-info.mt-5(@click="get_brochure()" :disabled="sending && loading.brochure")
              span.spinner-border.spinner-border-sm.mr-2(v-if="sending && loading.brochure")
              | Download Brochure
          .col-sm-12.text-center.pt-5
            a(href="#" @click.prevent="$router.go(-1)")
              i.feather-arrow-left
              | Back
        
        //- .row
        //-   .col-sm-12
        //-     qrcode(:value="qr")

            
      .col-sm-8(v-if="stall.startup")
        .row
          .col-sm-12
            //- .video-block
            #monitor
              #monitorscreen
                iframe.youtube(frameborder='0' scrolling='no' marginheight='0' marginwidth='0' type='text/html' :src="'https://www.youtube.com/embed/'+youtube_id(stall.startup.pitch_video)+'?autoplay=1&fs=0&iv_load_policy=3&rel=0&cc_load_policy=0&start=0&end=0&modestbranding=1&autohide=1&controls=0&showinfo=0'")

        .row
          .col-sm-4.mt-4(v-for="product in stall.startup.products")
            router-link.product(:to="{name: 'Product', params: {id: product.id}}" target='_blank')
              img(:src="$backend+'/storage/images/'+product.image")
              h3 {{product.name}}
              div
                span.badge.bg-azure.ml-2 {{product.sector}}
                span.badge.bg-teal.ml-2 {{product.subsector}}

      #details.modal.modal-blur.fade(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true')
        .modal-dialog.modal-sm.modal-dialog-centered(role='document')
          .modal-content
            button.close(type='button' data-dismiss='modal' aria-label='Close')
              i.feather-x
            form.modal-body.py-5(@submit.prevent="save_user()")
              form_input(type="text" name="name" label="Name" placeholder="Enter Your Name" v-model="user.name" :required="true")  
              form_input(type="number" name="phone" label="Phone" placeholder="Enter Your Phone Number" v-model="user.phone" :required="true")  
              form_input(type="email" name="email" label="Email" placeholder="Enter Your Email Address" v-model="user.email" :required="true")  
              form_input(type="text" name="organisation" label="Organisation" placeholder="Enter Your Organisation Name" v-model="user.organisation" :required="true")  
              .mb-3
                label.form-label Type
                select.form-select(v-model="user.type")
                  option Mentor
                  option Investor
                  option Industry
                  option Individual
              .d-flex
                button.btn.btn-primary.ml-auto(type="submit")
                  .spinner-border.spinner-border-sm.mr-2(v-if="sending")
                  | Submit

      #business.modal.modal-blur.fade(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true')
        .modal-dialog.modal-sm.modal-dialog-centered(role='document')
          .modal-content
            .modal-body.p-0.text-center
              qrcode.qrcode(:value="business" :options="{ color: { light: '#ffffff00' } }")
              h4.text-center.pt-1.pb-5 Scan Qr Code

      #live.modal.modal-blur.fade(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true')
        .modal-dialog.modal-sm.modal-dialog-centered(role='document')
          .modal-content
            button.close(type='button' data-dismiss='modal' aria-label='Close')
              i.feather-x
            .modal-body.py-5.text-center
              .d-block
                img.img-fluid.w-50(src="../../assets/img/live.png")
              a.button.btn.btn-success.mt-5(:href="live" target="_blank") Start Live Interaction
              

      #brochure.modal.modal-blur.fade(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true')
        .modal-dialog.modal-sm.modal-dialog-centered(role='document')
          .modal-content
            button.close(type='button' data-dismiss='modal' aria-label='Close')
              i.feather-x
            .modal-body.py-5
              .d-block
                img.img-fluid.w-50(src="../../assets/img/download.png")
              a.button.btn.btn-success.mt-5(:href="brochure" target="_blank") Download Brochure

</template>

<script>
// @ is an alias to /src
import page from '@/components/page_blank'
import magnificPopup from 'magnific-popup';
import modal from '@/components/modal';
import pagination from '@/components/pagination';
import youtube from '@/components/youtube';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import form_input from '@/components/formInput'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Stall',
  props: ['id'],
  components: {
    page,
    pagination,
    youtube,
    qrcode: VueQrcode,
    form_input
  },
  data(){
    return {
      stall: [],
      brochure: '',
      live: '',
      business: 'qr',
      loading: {
        business: false,
        live: false,
        brochure: false
      },
      user:{

      }
    }
  },
  computed:{
    ...mapState('api', ['sending']),
  },
  methods:{
    read_user_details(){
      var user = localStorage.getItem('stall_user_new');
      if(user){
        user = JSON.parse(user);
        if(user.name && user.email && user.phone && user.organisation){
          this.user = user;
          return true;
        }
      }
    },
    business_card(){
      this.loading.business = true;

      if(this.read_user_details()){
        this.show_details('business');
      }
      else{
        $('#details').modal('show');
      }
      
    },
    live_interact(){
      this.loading.live = true;

      if(this.read_user_details()){
        this.show_details('live');
      }
      else{
        $('#details').modal('show');
      }

    },
    get_brochure(){
      this.loading.brochure = true;

      if(this.read_user_details()){
        this.show_details('brochure');
      }
      else{
        $('#details').modal('show');
      }

    },
    save_user(){
      
      if(this.loading.business){
        this.show_details('business')
        this.$gtag.event('business_card', { method: 'business_card' })
      }
      else if(this.loading.live){
        this.show_details('live')
        this.$gtag.event('live_interaction', { method: 'live_interaction' })
      }
      else if(this.loading.brochure){
        this.show_details('brochure')
        this.$gtag.event('download_brochure', { method: 'download_brochure' })
      }
      else{
        this.show_details('stall')
        this.$gtag.event('visit_stall', { method: 'visit_stall' })
      }
    },
    show_details(content){
      var vm = this;
      this.call({ _vm: this, endpoint:'stall/'+this.id+'/show/'+content, method: 'POST' , data:this.user })
        .then((response)=>{
          $('#details').modal('hide');
          vm.detail_response(content, response);
        });
    },
    detail_response(content, response){
      localStorage.setItem('stall_user_new', JSON.stringify(this.user));
      if(response[content]){
        // console.log(response[content]);
        this[content] = response[content];
        if(content=="business"){
          $('#'+content).modal('show');
        }
        else if(content=="live" || content=="brochure"){
          window.open(response[content],'_blank');
        }
      }
      this.loading[content] = false;
    },
    youtube_id(url){
      var url = url??'';
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
      // return video_id;
    },
    load_data(){
      var vm = this;
      this.call({ _vm: this, endpoint:'stall/'+this.id, method: 'POST' })
        .then((response)=>{
          vm.stall = response.data;
        });
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    if(this.read_user_details()){
      // this.load_data();
      this.show_details('stall');
    }else{
      $('#details').modal('show');
    }
  }
}
</script>

<style lang="scss" scoped>
.glowing{
  transition: all 1s ease;
  animation: glowing 1300ms infinite;
}

@keyframes glowing {
  0% {
    // background-color: #0091b2;
    box-shadow: 0 0 3px #9b0c02;
    color: white;
    transform: scale(.9);
  }
  50% {
    // background-color: #21c7ed;
    box-shadow: 0 0 15px #f83325;
    color: yellow;
    transform: scale(1.1);
  }
  100% {
    // background-color: #0091b2;
    box-shadow: 0 0 3px #9b0c02;
    color: white;
    transform: scale(.9);
  }
}

.startup-details{
  border: 1px solid #e7eaf3 ;
  transition: 0.3s;
  display: block;
  padding: 15px 30px;
  color: #1e2022;
  border-radius: 0.25rem;
  box-shadow: 0 0 35px rgba(140, 152, 164, 0.125);
  font-family: 'Poppins';
  background: white;
}

.video-block{
  display: inline-block;
  background: white;
  padding: 10px 10px 10px 10px;
  box-shadow: 1px 1px 3px #666;

  iframe{
    max-width: 100%;
  }

  img{
    max-width:100%;
  }
}

.youtube{
  max-width: 100%;
}

.product{
  display: block;
  box-shadow: 2px 2px 5px rgba(200,200,200,.5);
  padding: 10px;
  border-radius: 5px;
  transition: all .5s ease;
  height: 100%;
  background: white;
  &:hover{
    text-decoration: none;
    transform: translateY(-5px);
    box-shadow: 2px 2px 5px rgba(0,0,0,.3);

  }
  h3{
    margin-top: 10px;
  }
}

.button{
  border-radius: 10rem;
  width: 50%;
}

// .qrcode{
//   // margin-top: 10px;
//   // box-shadow: 2px 2px 5px rgba(200,200,200,.5);
// }

#monitor {
	background: #000; 
	position: relative;
	border-top: 3px solid #888; 
	margin: 5%;
	padding: 2% 2% 4% 2%; 
	border-radius: 10px; 
	border-bottom-left-radius: 50% 2%; 
	border-bottom-right-radius: 50% 2%; 
	transition: margin-right 1s;
}

#monitor:after {
	content: '';
	display: block;
	position: absolute;
	bottom: 3%;
	left: 36%;
	height: .5%; 
	width: 28%;
	background: #ddd; 
	border-radius: 50%; 
	box-shadow: 0 0 3px 0 white; 
}

#monitorscreen {
	position: relative;
  background-color: #777;
	background-size: cover; 
	background-position: top center;
	height: 0; 
	padding-bottom: 56.25%; 
	position: relative;
	overflow: hidden;

  iframe{
    position: absolute; top: 0; left: 0; width: 100%; height: 100%;
  }
}


@media all and (min-width: 960px) {
	#monitor {
		-webkit-animation: tvflicker .2s infinite alternate; 
		-moz-animation:    tvflicker .5s infinite alternate; 
		-o-animation:      tvflicker .5s infinite alternate; 
		animation:         tvflicker .5s infinite alternate; 
	}

	@-webkit-keyframes tvflicker {
	  0%   { box-shadow: 0 0 100px 0 rgba(200,235,255,0.4); }
	  100% { box-shadow: 0 0 95px 0 rgba(200,230,255,0.45); }
	}
	@-moz-keyframes tvflicker {
	  0%   { box-shadow: 0 0 100px 0 rgba(225,235,255,0.4); }
	  100% { box-shadow: 0 0 60px 0 rgba(200,220,255,0.6); }
	}
	@-o-keyframes tvflicker {
	  0%   { box-shadow: 0 0 100px 0 rgba(225,235,255,0.4); }
	  100% { box-shadow: 0 0 60px 0 rgba(200,220,255,0.6); }
	}
	@keyframes tvflicker {
	  0%   { box-shadow: 0 0 100px 0 rgba(225,235,255,0.4); }
	  100% { box-shadow: 0 0 60px 0 rgba(200,220,255,0.6); }
	}
}

</style>